import * as _ from 'lodash';

import { BreakpointObserver } from '@angular/cdk/layout';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AutoUnsubscribe } from 'helpers';

import { MediaObserverRules } from '../constants';

@AutoUnsubscribe
@Directive({
    selector: '[fcMediaWrapper]',
    standalone: false
})
export class MediaWrapperDirective {
    @Input() set fcMediaWrapper(media: 'mobile' | 'desktop') {
        this.selectedMediaSubject.next(media);
    }

    public selectedMediaSubscription: Subscription;
    private selectedMediaSubject: Subject<'mobile' | 'desktop'>;

    private isRendered = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        breakpointObserver: BreakpointObserver
    ) {
        this.selectedMediaSubject = new Subject<'mobile' | 'desktop'>();
        this.selectedMediaSubscription = this.selectedMediaSubject
            .pipe(
                switchMap((selectedMedia) =>
                    breakpointObserver.observe(MediaObserverRules[_.capitalize(selectedMedia)])
                )
            )
            .subscribe((layoutChange) => {
                if (layoutChange.matches) {
                    if (!this.isRendered) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                        this.isRendered = true;
                    }
                } else {
                    this.viewContainer.clear();
                    this.isRendered = false;
                }
            });
    }
}
